module.exports = __webpack_public_path__ + "static/media/dailystep.9bc8ab39.svg";